module.exports = "img/icons-create-room.817ede2.svg";